import React from 'react'

// Small line icons for the GT-2 feature surfaces (the key-feature tiles in the
// configurator buy box and the comparison table rows). 24px grid, 1.75 stroke,
// currentColor, so the caller sets colour and size. Pure SVG, no state, so the
// RSC twin of the comparison table can import them too.

function Icon({ children, size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {children}
    </svg>
  )
}

// Gauge: torque / direct drive rating.
export const TorqueIcon = (p) => (
  <Icon {...p}><path d="M4.5 17a8 8 0 1 1 15 0"/><path d="M12 13l4-4"/><circle cx="12" cy="13" r="1.4"/><path d="M4 20h16"/></Icon>
)

// Steering wheel: wheelbase mount.
export const WheelIcon = (p) => (
  <Icon {...p}><circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="2.2"/><path d="M3.8 10.5h6M14.2 10.5h6M12 14.2v6.2"/></Icon>
)

// Extrusion cross-section: aluminium profile.
export const ProfileIcon = (p) => (
  <Icon {...p}><rect x="3" y="7" width="18" height="10" rx="1.5"/><path d="M7 7v3M12 7v3M17 7v3M7 17v-3M12 17v-3M17 17v-3"/></Icon>
)

// Rails: seat sliders and brackets.
export const RailsIcon = (p) => (
  <Icon {...p}><path d="M3 9h18M3 15h18"/><path d="M7 6v12M17 6v12"/><rect x="9.5" y="7.5" width="5" height="9" rx="1"/></Icon>
)

// Bucket seat: seating positions.
export const SeatIcon = (p) => (
  <Icon {...p}><path d="M8 3h5a2 2 0 0 1 2 2.2l-1 8.8H8.5A2.5 2.5 0 0 1 6 11.5V5a2 2 0 0 1 2-2z"/><path d="M8.5 14l-1 6M14 14h3.5a2 2 0 0 1 2 2.2V20"/></Icon>
)

// Sliders: adjustment.
export const AdjustIcon = (p) => (
  <Icon {...p}><path d="M5 4v16M12 4v16M19 4v16"/><circle cx="5" cy="14" r="2" fill="currentColor"/><circle cx="12" cy="8" r="2" fill="currentColor"/><circle cx="19" cy="16" r="2" fill="currentColor"/></Icon>
)

// Grid with a plus: modular accessory mounting.
export const ModularIcon = (p) => (
  <Icon {...p}><rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><path d="M17 14v6M14 17h6"/></Icon>
)

// Three swatches: colour options.
export const ColoursIcon = (p) => (
  <Icon {...p}><circle cx="8" cy="9" r="4.5"/><circle cx="16" cy="9" r="4.5"/><circle cx="12" cy="16" r="4.5"/></Icon>
)

// Wrench: assembly.
export const WrenchIcon = (p) => (
  <Icon {...p}><path d="M14.7 6.3a4 4 0 0 0 5 5L21 13l-1.3 1.3-1.6-1.6-7.6 7.6a2 2 0 0 1-2.8-2.8l7.6-7.6-1.6-1.6L15 3a4 4 0 0 0-.3 3.3z"/></Icon>
)

// Ring of stars: made in the EU.
export const EuIcon = (p) => (
  <Icon {...p}>
    {Array.from({ length: 12 }, (_, i) => {
      const a = (i / 12) * Math.PI * 2
      return <circle key={i} cx={12 + Math.sin(a) * 7.5} cy={12 - Math.cos(a) * 7.5} r="1.35" fill="currentColor" stroke="none"/>
    })}
  </Icon>
)

// Shield with a check: warranty.
export const ShieldIcon = (p) => (
  <Icon {...p}><path d="M12 3l7.5 3v5.5c0 4.4-3.2 8.2-7.5 9.5-4.3-1.3-7.5-5.1-7.5-9.5V6z"/><path d="M8.8 12.2l2.3 2.3 4.3-4.6"/></Icon>
)

// Circular arrow: money-back returns.
export const ReturnIcon = (p) => (
  <Icon {...p}><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/></Icon>
)

// Trophy: raced by pros.
export const TrophyIcon = (p) => (
  <Icon {...p}><path d="M8 4h8v5a4 4 0 0 1-8 0z"/><path d="M8 6H4.5v1.5A3 3 0 0 0 8 10.4M16 6h3.5v1.5a3 3 0 0 1-3.5 2.9"/><path d="M12 13v4M8.5 20h7M9.5 17h5"/></Icon>
)
